module.exports = __webpack_public_path__ + "media/icons/kalendarz-f042756b.png";